/* istanbul ignore file */
// jsdom sets global === global.window so testing
// this wouldn't be easy at all
// This is "server" for SSR, not CircleCI server
export default typeof window === 'undefined';
